import React from 'react';

import { useTypedSelector } from '@cube3/state/src/redux/components/Hooks/useTypedSelector';
import { getFormValues } from 'redux-form';
import { ContractAssetsPicker } from './variants/ContractAssetsPicker';

import { ContractProjectsPicker } from './variants/ContractProjectsPicker';
import { ContractRecipientsPicker } from './variants/ContractRecipientsPicker';
import { PublicResource } from '@cube3/common/model/resource-types';
import { SuggestionItem } from './SuggestionsPickerBase';

const emptyArray = [];

interface Props {
  form: string;
  value: SuggestionItem[];
  name: string;
  variant: 'contract-assets' | 'contract-projects' | 'contract-recipients';
  lockedResources?: PublicResource[];
}

export const MultipleResourcePickerSmart: React.FunctionComponent<Props> = (
  props
) => {
  const {
    variant,
    form,
    value,
    name,
    lockedResources
    // clearOn = 'all'
  } = props;

  const query = useTypedSelector((state) => {
    return (
      getFormValues(form)(state) &&
      getFormValues(form)(state)[`${name}_inputValue`]
    );
  });

  const selected = value || emptyArray;

  switch (variant) {
    case 'contract-assets':
      return (
        <ContractAssetsPicker
          {...props}
          selected={selected}
          query={query}
          form={form}
          lockedResources={lockedResources}
          // clearOn={clearOn}
          type={'asset'}
        />
      );
    case 'contract-projects':
      return (
        <ContractProjectsPicker
          {...props}
          form={form}
          selected={selected}
          query={query}
          lockedResources={lockedResources}
          //  clearOn={clearOn}
          type={'project'}
        />
      );
    case 'contract-recipients':
      return (
        <ContractRecipientsPicker
          {...props}
          form={form}
          selected={selected}
          query={query}
          // clearOn={clearOn}
          locked={lockedResources}
          type={'account'}
        />
      );
    default:
      return <div>No valid picker variant selected</div>;
  }
};
